import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  fetchHouse,
  cancelAuthentication,
  updateAuthApplyNotifyYn,
  updateAgreeCollectTerms,
  fetchNpayAuthentication,
  cancelAuthenticationCount,
} from '@Root/slices/myhouse/authentication'
import { RootState } from '@Root/slices'

export default function useAuthentication() {
  const dispatch = useDispatch()
  const authentication = useSelector((state: RootState) => state.authentication)

  const loadAuthentication = useCallback(
    (myhouseNo: number) => {
      dispatch(fetchHouse(myhouseNo))
    },
    [dispatch],
  )

  const updateAuthentication = useCallback(
    (myhouseNo: number) => {
      dispatch(cancelAuthentication(myhouseNo))
    },
    [dispatch],
  )

  const updateAuthenticationCount = useCallback(
    (myhouseNo: number) => {
      dispatch(cancelAuthenticationCount(myhouseNo))
    },
    [dispatch],
  )

  const loadNpayAuthentication = useCallback(
    (myhouseNo: number) => {
      dispatch(fetchNpayAuthentication(myhouseNo))
    },
    [dispatch],
  )

  const setAgreeCollectTerms = useCallback(
    (agreeCollectTerms: boolean) => {
      dispatch(updateAgreeCollectTerms(agreeCollectTerms))
    },
    [dispatch],
  )

  const setAuthApplyNotifyYn = useCallback(
    (authApplyNotifyYn: 'Y' | 'N') => {
      dispatch(updateAuthApplyNotifyYn(authApplyNotifyYn))
    },
    [dispatch],
  )

  return {
    authentication,
    loadAuthentication,
    updateAuthentication,
    updateAuthenticationCount,
    loadNpayAuthentication,
    setAgreeCollectTerms,
    setAuthApplyNotifyYn,
  }
}
